import debug, { WARN } from './debug';
import { splitOnFirst } from './string';
export const getAndRemoveItem = (key) => {
    const value = localStorage.getItem(key);
    localStorage.removeItem(key);
    return value;
};
export const canUseLocalStorage = () => {
    try {
        const testKey = 'mol.ads.cmp.test';
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    }
    catch (e) {
        debug('Cannot use localStorage', WARN);
        return false;
    }
};
export const setLocalStorage = (name, value) => {
    if (canUseLocalStorage()) {
        localStorage.setItem(name, value);
    }
};
export const getLocalStorage = (name) => {
    if (canUseLocalStorage()) {
        return localStorage.getItem(name) || '';
    }
    return '';
};
export const removeLocalStorage = (name) => {
    if (canUseLocalStorage()) {
        localStorage.removeItem(name);
    }
};
export const getCookie = (name) => getValueFromCookie(document.cookie, name);
export const getValueFromCookie = (cookie, name) => {
    const decodedCookie = decodeURIComponent(cookie);
    const cookies = decodedCookie.split(/\s*;\s*/g);
    for (const cookie of cookies) {
        const [key, value] = splitOnFirst('=', cookie);
        if (name === key) {
            return value;
        }
    }
    return '';
};
export const setCookie = (name, value, exdays, path = '/') => {
    const date = new Date();
    date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${date.toUTCString()};path=${path};`;
};
export const deleteCookie = (name, path = '/') => {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=${path};`;
};
export const canUseCookies = () => {
    setCookie('mol.ads.cmp.test', 'success', 0.01);
    const success = getCookie('mol.ads.cmp.test') === 'success';
    deleteCookie('mol.ads.cmp.test');
    return success;
};
export const setCookieWithExpiry = (name, value, expires, path = '/') => {
    document.cookie = `${name}=${value};expires=${expires};path=${path}`;
};
export const restoreCookieFromLocalStorage = (name) => {
    const lsValue = getLocalStorage(name);
    const lsExpires = getLocalStorage(`${name}-expires`);
    if (lsValue && lsExpires) {
        const date = new Date();
        const expired = Date.parse(lsExpires) < date.getTime();
        if (expired) {
            removeLocalStorage(name);
            removeLocalStorage(`${name}-expires`);
            return false;
        }
        else {
            setCookieWithExpiry(name, lsValue, lsExpires);
            return true;
        }
    }
    return false;
};
